import { ECommunityAccessConfig, EUserRole } from '@/graphql-types/globalTypes';

import { tokenStorage } from '../../modules/accounts/tokenStorage';
import { useCurrent } from '../useCurrent';

export const usePermissions = (): {
  isLoading: boolean;
  isAuthenticated: boolean;
  canDoAdminStuffAndAuthenticated: boolean;
  canDoMorgothStuffAndAuthenticated: boolean;
  canAccessCommunityAndGroupFeed: boolean;
  canAccessDmPageAndAuthenticated: boolean;
  canAccessEventsFeed: boolean;
  canManageOrganizationProfileAndAuthenticated: boolean;
  canAccessCommunityAndAuthenticated: boolean;
} => {
  const current = useCurrent();

  let effectiveRole = current.user?.role;
  if (
    tokenStorage.getItem('isMobile') &&
    (effectiveRole === EUserRole.ADMIN ||
      effectiveRole === EUserRole.MORGOTH) &&
    current.user
  ) {
    effectiveRole = EUserRole.REGULAR_USER;
  }

  return {
    isLoading: current.loading,
    isAuthenticated: !!current.user?._id,
    canDoAdminStuffAndAuthenticated:
      effectiveRole === EUserRole.ADMIN || effectiveRole === EUserRole.MORGOTH,
    canDoMorgothStuffAndAuthenticated: effectiveRole === EUserRole.MORGOTH,
    canAccessCommunityAndGroupFeed: current.tenant?.communityAccessConfig
      ? {
          [ECommunityAccessConfig.PUBLIC]:
            current.user?.canAccessCommunity ?? true,
          [ECommunityAccessConfig.LOGGED_IN_USERS]:
            current.user?.canAccessCommunity ?? false,
          [ECommunityAccessConfig.MEMBERS_ONLY]:
            current.user?.canAccessCommunity ?? false,
        }[current.tenant.communityAccessConfig]
      : false,
    canAccessDmPageAndAuthenticated: current.user?.canAccessDMPage ?? false,
    canAccessEventsFeed:
      current.tenant?.currentUserPermissions?.canAccessEventsFeed ?? false,
    canManageOrganizationProfileAndAuthenticated:
      current.user?.rosterOrganization?.currentUserOrganizationPermission
        .canManageOrganizationProfile ?? false,
    canAccessCommunityAndAuthenticated:
      current.user?.canAccessCommunity ?? false,
  };
};
